import { GAME_ID, REDUX_ACTIONS } from 'a/cutItOut/data/constants';

const initialState = {
  head: null,
  body: null,
  tail: null,
  animalIndex: 0,
};

const bonusGameModalReducer = (state = initialState, action) => {
  if (action.gameId !== GAME_ID) {
    return state;
  }

  switch (action.type) {
    case REDUX_ACTIONS.LOAD_MODAL:
      return {
        ...state,
        head: action.payload.head,
        body: action.payload.body,
        tail: action.payload.tail,
        animalIndex: action.payload.animalIndex,
      };
    default:
      return state;
  }
};

export default bonusGameModalReducer;
